
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export const searchAuxiliaresByTerm = async (
  search = '', 
  fields = ['primerNombre', 'primerApellido', 'identificacion']
) => {

  const queryFields = fields.join(',');

  const query = `
    query MyQuery($search: String) {
      allAuxmed(search: $search) {
        status
        total
        auxiliar {
          urlFirmaSello
          id
            idPersona {
              ${queryFields}
            }
          }
      }
    }
  `;
  const variables = { search }

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables } );
    const { data } = response;
    return data.data.allAuxmed.auxiliar;

  } catch (error) {
    console.error("Error fetching Auxiliares:", error);
  }
}


const searchAuxiliaresByTermSelect = async (search) => {

  const response = await searchAuxiliaresByTerm(search);

  const data = response.map(item => ({
    value: item.id,
    text: `${item.idPersona.primerApellido} ${item.idPersona.primerNombre}`,
    urlFirmaSello: item.urlFirmaSello
  }));

  return data;
}


export const auxiliarService = {
  searchAuxiliaresByTerm,
  searchAuxiliaresByTermSelect
}